import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import StartPage from "./pages";
import LoginPage from "./pages/login";
import ProtectedRoute from "./ProtectedRoute";
import AdminLayout from "./layouts/AdminLayout";
import PracticesPage from "./pages/admin/mwi/practices";
import AdminPage from "./pages/admin";
import UserManagementPage from "./pages/admin/mwi/user-management";
import ForgotPasswordPage from "pages/password/forgot";
import ResetPasswordPage from "pages/password/reset";
import AccountPage from "pages/admin/account";
import MwiAdminLayout from "pages/admin/mwi";
import VocabularyPage from "pages/admin/customisations/vocabulary";
import LogoPage from "pages/admin/customisations/logo";
import ColoursPage from "pages/admin/customisations/colours";
import LoginImagePage from "pages/admin/customisations/login_image";
import LinksPage from "pages/admin/customisations/links";
import CustomisationsLayout from "pages/admin/customisations";
import PracticeSettingsLayout from "pages/admin/settings";
import PracticeAppointmentsPage from "pages/admin/settings/appointments";
import PracticeFeaturesPage from "pages/admin/settings/features";
import PracticeUserManagementPage from "pages/admin/settings/user-management";
import PractitionersPage from "pages/admin/settings/practitioners";
import VerifyAccountPage from "pages/verify";
import TermsPage from "pages/policies/terms";
import PrivacyPage from "pages/policies/privacy";
import CookiePage from "pages/policies/cookie";
import OwnerManagementPage from "pages/admin/settings/owner-management";

const Router = () => {
  return (
    <BrowserRouter>
      <App>
        <Routes>
          <Route path="/" element={<StartPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify" element={<VerifyAccountPage />} />

          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookie" element={<CookiePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminPage />} />
              <Route
                path="/admin/customisations"
                element={<CustomisationsLayout />}
              >
                <Route path="logo" element={<LogoPage />} />
                <Route path="colours" element={<ColoursPage />} />
                <Route path="login-page" element={<LoginImagePage />} />
                <Route path="vocabulary">
                  <Route path="" element={<VocabularyPage />} />
                  <Route path=":id" element={<VocabularyPage />} />
                </Route>
                <Route path="links" element={<LinksPage />} />
              </Route>
              <Route
                path="/admin/settings"
                element={<PracticeSettingsLayout />}
              >
                <Route
                  path="appointments"
                  element={<PracticeAppointmentsPage />}
                />
                <Route path="features" element={<PracticeFeaturesPage />} />
                <Route
                  path="user-management"
                  element={<PracticeUserManagementPage />}
                />
                <Route
                  path="owner-management"
                  element={<OwnerManagementPage />}
                />
                <Route path="practitioners">
                  <Route path="" element={<PractitionersPage />} />
                  <Route
                    path=":practitionerId"
                    element={<PractitionersPage />}
                  />
                </Route>
              </Route>
              <Route path="/admin/account" element={<AccountPage />} />

              <Route path="/admin/mwi" element={<MwiAdminLayout />}>
                <Route path="practices" element={<PracticesPage />} />
                <Route path="users" element={<UserManagementPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </App>
    </BrowserRouter>
  );
};

export default Router;
